<template>
  <div class="tabbar4">
    <div class="top">
      <van-nav-bar
        left-text="返回"
        title="购物车"
        right-text="更多"
        left-arrow
        @click-left="onClickLeft('/index/tabbar1')"
      />
    </div>
    <img v-if="$store.state.empty.length == 0" class="img" src="~@/assets/images/gwc.png" alt />
    <van-checkbox-group v-model="result" ref="checkboxGroup">
      <div v-for="(item,index) in kon" :key="index" class="box">
        <div class="box_up">
          <span class="iconfont icondianpu"></span>
          <span>京东自营</span>
        </div>
        <div class="box_conter">
          <div class="box_conter_left">
            <van-checkbox :name="index" @click="cyl(index)"></van-checkbox>
          </div>
          <div class="box_conter_right">
            <div class="box_conter_right_left">
              <img :src="item.selectedSkuComb.imgUrl" alt />
            </div>
            <div class="box_conter_right_right">
              <p>{{item.selectedSkuComb.s3}}</p>
              <p>
                iPhone {{item.selectedSkuComb.s1}}
                {{item.selectedSkuComb.s2}}
              </p>
              <p>12期免息</p>
            </div>
          </div>
        </div>
        <div class="box_below">
          <em>￥{{item.selectedSkuComb.price/100}}</em>
          <div>x{{item.selectedNum}}</div>
          <!-- <div>
            <van-stepper v-model="value" />
          </div>-->
        </div>
      </div>
    </van-checkbox-group>
    <div class="price">
      <!-- <div class="price_1">
        <van-checkbox v-model="checked" @click="toggleAll">全选</van-checkbox>
      </div>-->
      <div class="price_2">
        <span class="price_2_left">总计:</span>
        <span class="price_2_right">{{qrice}}&nbsp;元</span>
      </div>
      <div class="price_3" @click="no()">提交订单</div>
    </div>
  </div>
</template>
<script>
import data from "@/data/tabbar4_data.js";
// const show1 = () => import("@/components/show/show1.vue");
export default {
  name: "tabbar4",
  components: {
    // 组件注册
    // show1
  },
  data() {
    return {
      index1: null,
      result: [],
      kon: null,
      value: 0,
      checked: false,
      qrice: null,
      nul: 0
    };
  },
  methods: {
    cyl(i) {
      this.nul = 0;
      for (let l of this.result) {
        this.nul +=
          (this.kon[l].selectedNum * this.kon[l].selectedSkuComb.price) / 100;
      }
      this.qrice = this.nul;
      // ========================================================================
    },
    // toggleAll() {
    //   this.$refs.checkboxGroup.toggleAll();
    //   !this.checked;
    //   console.log(this.checked);
    //   if (this.checked == true) {
    //     this.cyl();
    //   } else {
    //     this.qrice = 0;
    //   }
    // },
    onClickLeft(innn) {
      this.index1 = innn;
      this.$store.commit("change", innn);
      this.$router.push(innn);
    },
    no() {
      if (this.kon.length !== 0 && this.qrice !== 0) {
        this.$toast("购买成功");
      } else if (this.kon.length !== 0 && this.qrice == 0) {
        this.$toast("请先选中商品");
      } else {
        this.$toast(" 请先添加 商品 到购物车");
      }
    }
  },
  updated() {
    this.index1 = this.$router.currentRoute.path;
  },
  mounted() {
    // Vue实例渲染完成后执行
    this.kon = this.$store.state.empty;
    this.qrice = 0;
  }
};
</script>
<style scoped lang="scss">
@import url("~@/assets/icon/iconfont.css");
@import url("~@/assets/css/tabbar4/tabbar4.css");
.tabbar4 {
  background-color: #f2f2f2;
  .img {
    margin-top: 9rem;
    width: 100%;
  }
}
</style>
